import { IHeadCell } from 'features/common/types';

export const headerCells: IHeadCell[] = [
	{
		field: 'created',
		sortable: true,
		headerName: 'Fecha',
	},
	{
		field: 'createdBy',
		sortable: false,
		headerName: 'Creada por',
	},
	{
		field: 'dealId',
		sortable: true,
		headerName: 'Deal ID o Caso',
	},
	{
		field: 'customersCompleteName',
		sortable: false,
		headerName: 'Cliente',
	},
	{
		field: 'chargedPercent',
		sortable: false,
		headerName: '% Cobrado',
	},
	{
		field: 'invoicedPercent',
		sortable: false,
		headerName: '% Facturado',
	},
	{
		field: 'invoicingStatus',
		sortable: false,
		headerName: 'Estado de facturación',
	},
	// {
	// 	field: 'quotationId',
	// 	sortable: false,
	// 	headerName: 'Quotation ID',
	// },
	{
		field: 'currency',
		sortable: false,
		headerName: 'Moneda',
	},
	{
		field: 'salesAmount',
		sortable: false,
		headerName: 'Venta',
	},
	{
		field: 'totalCost',
		sortable: false,
		headerName: 'Costo',
	},
	{
		field: 'grossProfit',
		sortable: false,
		headerName: 'Margen Bruto',
	},
	{
		field: 'grossProfitPercent',
		sortable: false,
		headerName: 'MB %',
	},
	{
		field: 'chargedAmount',
		sortable: true,
		headerName: 'Cobro',
	},
	{
		field: 'pendingPayAmount',
		sortable: true,
		headerName: 'Saldo',
	},
	{
		field: 'mainPassengerCompleteName',
		sortable: false,
		headerName: 'Pasajero Principal',
	},
	{
		field: 'destinations',
		sortable: false,
		headerName: 'Destinos',
	},
	{
		field: 'travelDepartureDate',
		sortable: true,
		headerName: 'Inicio de Viaje',
	},
	{
		field: 'daysToTravel',
		sortable: false,
		headerName: 'Días para viaje',
	},
	{
		field: 'travelReturnDate',
		sortable: true,
		headerName: 'Fin de Viaje',
	},
	{
		field: 'isReturnDateReached',
		sortable: false,
		headerName: 'Viaje finalizado',
	},
	{
		field: 'lastSuccessSyncAt',
		sortable: false,
		headerName: 'Ult. sincronización',
	},
	{
		field: 'updated',
		sortable: true,
		headerName: 'Ult. edición',
	},
	{
		field: 'segmentType',
		sortable: false,
		headerName: 'Segmento',
	},
	{
		field: 'channel',
		sortable: false,
		headerName: 'Canal',
	},
	{
		field: 'clientReference',
		sortable: false,
		headerName: 'Referencia del cliente',
	},
	{
		field: 'servicesTypes',
		sortable: false,
		headerName: 'Servicios en la orden',
	},
];
